const PlateFormat = (plate, country = "ARGENTINA") => {
  if (!plate) return plate;

  const bullet = "·";
  const countryMap = {
    ARGENTINA: "AR",
    URUGUAY: "UY",
    CHILE: "CL",
    MEXICO: "MX",
    MÉXICO: "MX",
    PERU: "PE",
    COLOMBIA: "CO",
    ECUADOR: "EC",
    PARAGUAY: "PY",
    GUATEMALA: "GT",
    "COSTA RICA": "CR",
    "EL SALVADOR": "SV",
    "REPUBLICA DOMINICANA": "DO",
    "REPÚBLICA DOMINICANA": "DO",
    DOMINICANA: "DO",
    BOLIVIA: "BO",
  };

  const code = countryMap[country.trim().toUpperCase()] || "AR";
  const p = plate.toUpperCase().trim();

  const match = (regex) => new RegExp(regex).test(p);

  if (code === "AR") {
    if (match("^[A-Z]{2}[0-9]{3}[A-Z]{2}$"))
      return `${p.slice(0, 2)}${bullet}${p.slice(2, 5)}${bullet}${p.slice(5)}`;
    if (match("^[A-Z]{3}[0-9]{3}$"))
      return `${p.slice(0, 3)}${bullet}${p.slice(3)}`;
    if (match("^[A-Z][0-9]{2}[0-9][A-Z]{3}$"))
      return `${p.slice(0, 3)}${bullet}${p.slice(3)}`;
    return plate;
  }

  if (["UY", "EC"].includes(code)) {
    if (match("^[A-Z]{3}[0-9]{4}$") || match("^[A-Z]{3}[0-9]{3}$"))
      return `${p.slice(0, 3)}${bullet}${p.slice(3)}`;
    return plate;
  }

  if (code === "CL") {
    if (match("^[A-Z]{4}[0-9]{2}$"))
      return `${p.slice(0, 2)}${bullet}${p.slice(2, 4)}${bullet}${p.slice(4)}`;
    if (match("^[A-Z]{2}[0-9]{4}$"))
      return `${p.slice(0, 2)}${bullet}${p.slice(2)}`;
    return plate;
  }

  if (code === "MX") {
    if (match("^[A-Z]{3}[0-9]{3}[A-Z]$"))
      return `${p.slice(0, 3)}-${p.slice(3, 6)}-${p.slice(6)}`;
    if (match("^[A-Z]{3}[0-9]{4}$"))
      return `${p.slice(0, 3)}-${p.slice(3, 5)}-${p.slice(5)}`;
    if (match("^[A-Z][0-9]{2}[A-Z]{3}$"))
      return `${p.slice(0, 1)}${p.slice(1, 3)}-${p.slice(3)}`;
    return plate;
  }

  if (code === "PE") {
    if (match("^[A-Z]{3}[0-9]{3}$"))
      return `${p.slice(0, 3)}${bullet}${p.slice(3)}`;
    return plate;
  }

  if (code === "CO") {
    if (match("^[A-Z]{3}[0-9]{3}$"))
      return `${p.slice(0, 3)}${bullet}${p.slice(3)}`;
    if (match("^[A-Z]{3}[0-9]{2}[A-Z]$"))
      return `${p.slice(0, 3)}${bullet}${p.slice(3, 5)}${p.slice(5)}`;
    if (match("^[A-Z]{3}[0-9]{2}$"))
      return `${p.slice(0, 3)}${bullet}${p.slice(3)}`;
    return plate;
  }

  if (code === "PY") {
    if (match("^[0-9]{3}[A-Z]{3}[0-9]$"))
      return `${p.slice(0, 3)}${bullet}${p.slice(3, 6)}${bullet}${p.slice(6)}`;
    return plate;
  }

  if (code === "SV") {
    const p = plate.toUpperCase().trim();
    if (match("^[A-Z][0-9]{2}[A-Z0-9]{3}$"))
      return `${p.slice(0, 1)}${bullet}${p.slice(1, 3)}${bullet}${p.slice(3)}`;
    if (match("^[A-Z][0-9]{6}$"))
      return `${p.slice(0, 4)}${bullet}${p.slice(4)}`;
    // motos M195357
    if (match("^[A-Z][0-9]{6}$"))
      return `${p.slice(0, 1)}${bullet}${p.slice(1)}`;

    return plate;
  }

  if (["GT", "CR", "DO", "BO"].includes(code)) {
    if (match("^[A-Z]{3}[0-9]{3}$"))
      return `${p.slice(0, 3)}${bullet}${p.slice(3)}`;
    return plate;
  }

  return plate;
};

export default PlateFormat;
